import { SchoolSsvFilterResolver } from './../../resolvers/school-ssv/school-ssv-filter/school-ssv-filter.resolver';
import { ShelterIdResolver } from '../../resolvers/shelter-id/shelter-id.resolver';
import { StandardLayoutComponent } from '../../../shelter/layouts/standard-layout/standard-layout.component';
import { FullScreenLayoutComponent } from '../../../shelter/layouts/full-screen-layout/full-screen-layout.component';
import { SyncCombinatorGuard } from '../../guards/sync-combinator-guard/sync-combinator-guard';
import { RouteGuard } from '../../guards/route-guard/route-guard';
import { CurrentUserGuard } from '../../guards/current-user-guard/current-user-guard';
import { TogglesGuard } from '../../guards/toggles-guard/toggles-guards';
import { SchoolSingleColumnLayoutComponent } from 'Src/ng2/school/layouts/school-single-column-layout/school-single-column-layout.component';
import { SchoolSsvSortResolver } from '../../resolvers/school-ssv/school-ssv-sort/school-ssv-sort.resolver';
import { NoDistrictRouteGuard } from '../../guards/no-district-route-guard/no-district-route-guard';
import { PartnerTypes } from 'Src/ng2/shared/typings/interfaces/partner.interface';
import { ssvMatcher } from '../../url-matchers/ssv-matcher/ssv-matcher';

export const shelterRoute = {
  path: 'shelter',
  url: '/shelter',
  canActivate: [SyncCombinatorGuard],
  authenticationRequired: true,
  rolePermissions: ['all'],
  data: {
    guards: [NoDistrictRouteGuard, RouteGuard, CurrentUserGuard, TogglesGuard],
  },
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: '/not-found',
    },
    {
      path: ':shelterId',
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'lists/tiles', // first default path
        },
        {
          path: 'lists/tiles',
          component: StandardLayoutComponent,
          loadChildren: () => import('../../../school/tiles/tiles.module').then(m => m.TilesModule),
          resolve: {
            shelter: ShelterIdResolver,
          },
          data: {
            contextPartnerType: PartnerTypes.SHELTER,
          },
        },
        {
          path: 'lists',
          component: StandardLayoutComponent, // pass through
          loadChildren: () =>
            import('../../../shelter/list/shelter-list-routing.module').then(m => m.ShelterListRoutingModule),
          resolve: {
            shelter: ShelterIdResolver,
          },
          data: {
            contextPartnerType: PartnerTypes.SHELTER,
          },
        },
        {
          path: 'data-grid',
          loadChildren: () =>
            import('../../../school/server-side-grid/server-side-grid.module').then(m => m.ServerSideGridModule),
          resolve: {
            shelter: ShelterIdResolver,
          },
          data: {
            contextPartnerType: PartnerTypes.SHELTER,
          },
        },
        {
          matcher: ssvMatcher,
          component: SchoolSingleColumnLayoutComponent, // pass through
          loadChildren: () =>
            import('../../../student/student.module').then(m => m.StudentModule),
          resolve: {
            sort: SchoolSsvSortResolver,
            filter: SchoolSsvFilterResolver,
          },
          data: {
            contextPartnerType: PartnerTypes.SHELTER,
          },
        },
      ],
    },
  ],
};
